import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Breadcrumb as FluentBreadcrumb, BreadcrumbItem as FluentBreadcrumbItem, BreadcrumbDivider, makeStyles, tokens } from '@fluentui/react-components';
import { BreadcrumbItem } from '../types';

interface BreadcrumbProps {
  path: BreadcrumbItem[];
  onNavigate?: (level: number) => void;
}

const useStyles = makeStyles({
  breadcrumbLink: {
    textDecoration: 'none',
    color: tokens.colorBrandForegroundLink,
    ':hover': {
      textDecoration: 'underline',
      color: tokens.colorBrandForegroundLinkHover,
    },
  },
  breadcrumbLinkCurrent: {
    textDecoration: 'none',
    color: tokens.colorNeutralForeground1,
    fontWeight: 'bold',
  },
});

const Breadcrumb: React.FC<BreadcrumbProps> = ({ path, onNavigate }) => {
  const navigate = useNavigate();
  const styles = useStyles();

  const handleClick = (level: number): void => {
    if (onNavigate) {
      onNavigate(level);
    } else {
      // Default navigation based on level
      const routes: Record<number, string> = {
        0: '/',
        1: `/${path[0]?.value}`,
        2: `/${path[0]?.value}/${path[1]?.value}`,
        3: `/${path[0]?.value}/${path[1]?.value}/${path[2]?.value}`,
        4: `/${path[0]?.value}/${path[1]?.value}/${path[2]?.value}/${path[3]?.value}`,
      };
      navigate(routes[level] || '/');
    }
  };

  if (!path || path.length === 0) {
    return null;
  }

  return (
    <div style={{ marginBottom: '1rem' }}>
      <FluentBreadcrumb>
        <FluentBreadcrumbItem>
          <button
            type="button"
            onClick={() => handleClick(0)}
            className={styles.breadcrumbLink}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              font: 'inherit',
              cursor: 'pointer',
            }}
          >
            Home
          </button>
        </FluentBreadcrumbItem>
        {path.map((item, index) => (
          <React.Fragment key={index}>
            <BreadcrumbDivider />
            <FluentBreadcrumbItem>
              <button
                type="button"
                onClick={() => handleClick(index + 1)}
                className={index === path.length - 1 ? styles.breadcrumbLinkCurrent : styles.breadcrumbLink}
                style={{
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  font: 'inherit',
                  cursor: 'pointer',
                  fontWeight: index === path.length - 1 ? 'bold' : 'normal',
                }}
              >
                {item.label}
              </button>
            </FluentBreadcrumbItem>
          </React.Fragment>
        ))}
      </FluentBreadcrumb>
    </div>
  );
};

export default Breadcrumb;

